<div class="month-select-wrapper" [formGroup]="dateDropdownFg">
  <pg-select
    [value]="this.dateDropdownFg.get('month').value"
    style="min-width:120px; display:block"
    (itemSelected)="this.dateDropdownFg?.get('month')?.setValue($event.value)"
  >
    <span *ngFor="let index of monthIndexes" [pgOption]="index">{{
      monthsSvc.getMonthName(index)
    }}</span>
  </pg-select>
</div>
<div
  class="year-select-wrapper"
  style="min-width:100px; "
  [formGroup]="dateDropdownFg"
>
  <pg-select
    [value]="this.dateDropdownFg.get('year').value"
    (itemSelected)="this.dateDropdownFg?.get('year')?.setValue($event.value)"
  >
    <span *ngFor="let year of yearsArray" [pgOption]="year">{{ year }}</span>
  </pg-select>
</div>
<div class="flex-spacer"></div>
<div class="month-button-wrapper" tabindex="0">
  <i class="material-icons" (click)="handleBackArrowClicked()">arrow_back</i>
</div>
<div class="month-button-wrapper" tabindex="0">
  <i class="material-icons" (click)="handleFrontArrowClicked()"
    >arrow_forward</i
  >
</div>
